import { render, staticRenderFns } from "./fichafinanceira.vue?vue&type=template&id=51a93f03&scoped=true"
import script from "./fichafinanceira.vue?vue&type=script&lang=js"
export * from "./fichafinanceira.vue?vue&type=script&lang=js"
import style0 from "./fichafinanceira.vue?vue&type=style&index=0&id=51a93f03&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a93f03",
  null
  
)

export default component.exports